module.exports = __webpack_public_path__ + "static/media/patrol(6).36787d81.PNG";